/**
 * AI Model Config Service
 * Manages AI model configurations and available Bedrock models
 */

import axiosInstance, { apiRequest } from '../axiosInstance';
import { AI_MODEL_ENDPOINTS } from '../endpoints';

const aiModelService = {
  /**
   * Get all AI model configurations
   * @returns {Promise<Array>} List of AIModelConfigDto
   */
  getConfigs: async () => {
    return apiRequest(() =>
      axiosInstance.get(AI_MODEL_ENDPOINTS.LIST)
    );
  },

  /**
   * Update an AI model configuration
   * @param {number} id - Config ID
   * @param {Object} data - UpdateAIModelConfigDto
   * @returns {Promise<Object>} Updated AIModelConfigDto
   */
  updateConfig: async (id, data) => {
    return apiRequest(() =>
      axiosInstance.put(AI_MODEL_ENDPOINTS.UPDATE(id), data)
    );
  },

  /**
   * List available models for a provider (Bedrock foundation models, or the OpenRouter catalog)
   * @param {string} [provider='Bedrock'] - 'Bedrock' | 'OpenRouter'
   * @returns {Promise<Array>} List of AvailableModelDto
   */
  getAvailableModels: async (provider = 'Bedrock') => {
    return apiRequest(() =>
      axiosInstance.get(AI_MODEL_ENDPOINTS.AVAILABLE_MODELS, { params: { provider } })
    );
  },

  /**
   * Test a specific model against a provider
   * @param {string} modelId - Model ID to test
   * @param {string} [provider='Bedrock'] - 'Bedrock' | 'OpenRouter'
   * @returns {Promise<Object>} AITestResultDto
   */
  testModel: async (modelId, provider = 'Bedrock') => {
    return apiRequest(() =>
      axiosInstance.post(AI_MODEL_ENDPOINTS.TEST, { modelId, provider })
    );
  },
};

export default aiModelService;
